type DebouncedPromise<T> = Promise<T> & { terminate: () => void };

export function promiseDebounce<F extends (...args: any[]) => Promise<any>, T = Awaited<ReturnType<F>>>(
  debounced: F,
  interval = 300
): (...args: Parameters<F>) => DebouncedPromise<T> {
  if (typeof debounced !== 'function') {
    throw new Error('debounced should be a function');
  }
  if (typeof interval !== 'number') {
    throw new Error('interval should be a number');
  }
  let clock: any;
  return function (...args: Parameters<F>) {
    if (clock) {
      clearTimeout(clock);
      clock = undefined;
    }
    const promise = new Promise(function (resolve) {
      clock = setTimeout(function () {
        clock = undefined;
        resolve(debounced(...args));
      }, interval);
    });

    (promise as DebouncedPromise<T>).terminate = function () {
      clock && clearTimeout(clock);
    };
    return promise as DebouncedPromise<T>;
  };
}
